import React, { useState } from "react";
import api from "utils/api";
import { adminBrandParams } from "utils/brand";
import { DR_HOFFMANN_SERVICES } from "constants/massages";
import { useTeamAdminBrand } from "./TeamAdminBrandContext";
import { useTeamLocale } from "./TeamLocaleContext";

const todayIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const MASSAGE_TYPE_OPTIONS = [
  ...new Set(DR_HOFFMANN_SERVICES.map((s) => s.label).filter(Boolean)),
];

const parseEuroToCents = (raw) => {
  const value = String(raw || "").trim().replace(",", ".");
  if (!value) return null;
  const euros = Number(value);
  if (!Number.isFinite(euros) || euros <= 0) return null;
  return Math.round(euros * 100);
};

const ManualRevenueForm = ({ onCreated }) => {
  const { t } = useTeamLocale();
  const adminBrand = useTeamAdminBrand();
  const [amountEuro, setAmountEuro] = useState("");
  const [massageType, setMassageType] = useState("");
  const [entryDate, setEntryDate] = useState(todayIso);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const amountCents = parseEuroToCents(amountEuro);
    if (!amountCents) {
      return setError(t("revenue.amountRequired"));
    }
    if (!entryDate) {
      return setError(t("revenue.dateRequired"));
    }

    setSubmitting(true);
    try {
      await api.post(
        "/admin/revenue-entries",
        {
          amountEuro,
          massageType: massageType.trim() || undefined,
          entryDate,
        },
        { params: adminBrandParams({ brand: adminBrand }) }
      );
      setSuccess(t("revenue.success"));
      setAmountEuro("");
      setMassageType("");
      setEntryDate(todayIso());
      onCreated?.();
    } catch (err) {
      setError(err?.response?.data?.message || t("revenue.submitError"));
    } finally {
      setSubmitting(false);
    }
    return undefined;
  };

  return (
    <form className="team-manual-form team-revenue-form" onSubmit={handleSubmit}>
      <p className="team-lead">{t("revenue.formLead")}</p>

      {error && <div className="auth-alert is-error">{error}</div>}
      {success && <div className="auth-alert is-success">{success}</div>}

      <div className="booking-step">
        <div className="step-head">
          <h2>{t("revenue.formTitle")}</h2>
        </div>
        <div className="address-grid">
          <div>
            <label htmlFor="mr-amount">{t("revenue.amount")} *</label>
            <input
              id="mr-amount"
              type="text"
              inputMode="decimal"
              placeholder="0,00"
              value={amountEuro}
              onChange={(e) => setAmountEuro(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="mr-date">{t("revenue.date")} *</label>
            <input
              id="mr-date"
              type="date"
              value={entryDate}
              onChange={(e) => setEntryDate(e.target.value)}
              required
            />
          </div>
          <div className="full">
            <label htmlFor="mr-type">{t("revenue.massageType")}</label>
            <select
              id="mr-type"
              value={massageType}
              onChange={(e) => setMassageType(e.target.value)}
            >
              <option value="">{t("revenue.massageTypePlaceholder")}</option>
              {MASSAGE_TYPE_OPTIONS.map((label) => (
                <option key={label} value={label}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="team-manual-form-actions">
        <button type="submit" className="auth-submit" disabled={submitting}>
          {submitting ? t("revenue.submitting") : t("revenue.submit")}
        </button>
      </div>
    </form>
  );
};

export default ManualRevenueForm;
